<template>
    <div>
        <div v-if="authUserPermission['sap-sync-param-mapping-view']">
            <base-header class="pb-6">
                <div class="row align-items-center py-4">
                    <div class="col-lg-6 col-7">
                        <h6 class="h2 text-white d-inline-block mb-0"></h6>
                    </div>      
                </div>
            </base-header>
            <div class="container-fluid mt--6">
                <div class="card mb-4">
                    <div class="card-header mt--4 mb--4">
                        <div class="row">
                            <back></back>
                            <div class="col">
                                <h3 class="mb-0">{{ tt('sap_sync_param_mapping') }}</h3>
                            </div>
                            <div class="col-6">
                                <!-- <base-input input-classes="form-control-sm text-center border-radius-20" v-model="table.search" :placeholder="tt('search')" v-on:keyup="filter"/> -->
                            </div>
                            <div class="col text-right mb-3">
                                <base-button size="sm" type="default" @click="create" v-if="authUserPermission['sap-sync-param-mapping-create']">{{ tt('add_new') }}</base-button>
                            </div>
                        </div>
                    </div>
                    <div>
                        <el-table height="350px" class="table-responsive table-flush" header-row-class-name="thead-light" :data="table.data" v-if="!onLoad">
                            <el-table-column :label="tt('sap_sync_param_id')" :prop="tt('sap_sync_param_id')" min-width="170px" sortable>
                                <template v-slot="{row}">
                                    {{row.sap_sync_param_id}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('data_type')" :prop="tt('data_type')" min-width="170px" sortable>
                                <template v-slot="{row}">
                                    {{row.data_type}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('source_column')" :prop="tt('source_column')" min-width="170px" sortable>
                                <template v-slot="{row}">
                                    {{row.source_column}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('sap_column')" :prop="tt('sap_column')" min-width="190px" sortable>
                                <template v-slot="{row}">
                                    {{row.sap_column}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('update')" :prop="tt('update')" min-width="190px" sortable>
                                <template v-slot="{row}">
                                    {{row.update}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="action" width="100">
                                <template v-slot="{row}">
                                    <el-dropdown trigger="click" class="dropdown" @command="handleTableAction" :hide-on-click="true" v-if="authUserPermission['sap-sync-param-mapping-update'] || authUserPermission['sap-sync-param-mapping-delete']">
                                        <span class="btn btn-sm btn-icon-only text-light">
                                            <i class="fas fa-ellipsis-v mt-2"></i>
                                        </span>
                                        <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
                                            <el-dropdown-item :command="{action:'edit', data:row.id}" v-if="authUserPermission['sap-sync-param-mapping-update']">{{ tt('edit') }}</el-dropdown-item>
                                            <el-dropdown-item :command="{action:'remove', data:row.id}" v-if="authUserPermission['sap-sync-param-mapping-delete']">{{ tt('delete') }}</el-dropdown-item>                                      
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </template>
                            </el-table-column>
                        </el-table>
                        <page-loading v-else/>
                    </div>
                    <div class="card-footer pb-0 ">   
                        <!-- <span class="float-left">
                            <base-pagination :page-count="table.page.last_page" v-model="table.page.current_page" @click.native="changePage(table.page.current_page)" size="sm"></base-pagination>
                        </span>                             
                        <span class="float-right">
                            {{ tt('page_info', {size: (table.page.current_page - 1) * table.page.per_page + table.data.length, total: table.total}) }}
                        </span> -->
                    </div>
                </div>
            </div>
            <validation-observer v-slot="{invalid}">
                <modal :show.sync="form.show">
                    <template slot="header">
                        <h5 class="modal-title">{{form.title}}</h5>
                    </template>
                    <div>
                        <base-alert type="danger" v-if="errorMessage">
                            <p><strong>{{ errorMessage.message }}</strong></p>
                            <div v-if="errorMessage.data.length != 0">
                                <span v-for="message in errorMessage.data">
                                    {{ message[0] }}<br>
                                </span>
                            </div>
                        </base-alert>
                        <label class="form-control-label">{{ tt('data_type') }} </label>
                        <base-input :name="tt('data_type')" :placeholder="tt('data_type')" v-model="sapSyncParamMapping.data_type"></base-input>

                        <label class="form-control-label">{{ tt('source_column') }} </label>
                        <base-input :name="tt('source_column')" :placeholder="tt('source_column')" v-model="sapSyncParamMapping.source_column"></base-input>

                        <label class="form-control-label">{{ tt('sap_column') }}</label>
                        <base-input :name="tt('sap_column')" :placeholder="tt('sap_column')" v-model="sapSyncParamMapping.sap_column"></base-input>

                        <label class="form-control-label">{{ tt('update') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('update')" :placeholder="tt('update')" v-model="sapSyncParamMapping.update" rules="required|numeric"></base-input>
                    </div>
                    <template slot="footer">
                        <base-button type="secondary" @click="form.show = false">{{ tt('close') }}</base-button>
                        <base-button type="primary" v-on:click="save" :disabled="btnSave.onLoading || invalid">
                            <span v-if="btnSave.onLoading"><i class="fas fa-spinner fa-spin"></i> {{ tt('please_wait') }}</span>
                            <span v-else>
                                <span v-if="form.add">{{ tt('add') }}</span>
                                <span v-else>{{ tt('edit') }}</span>
                            </span>
                        </base-button>
                    </template>
                </modal>
            </validation-observer>
        </div>
        <noaccess v-else/>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import Api from '@/helpers/api';
    import sapSyncParamMapping from '@/services/sap/sapSyncParamMapping.service';

    export default {        
        data() {
            return { 
                onLoad: true, 
                loadTimeout: null, 
                errorMessage: null,
                btnSave: {
                    onLoading: false
                },                  
                form: {
                    add: true,
                    title: this.tt('add_sap_synchron_master'),
                    show: false
                }, 
                table: {
                    search: '',                    
                    total: 0,
                    data: [],
                    page: {
                        current_page: 1,
                        per_page: 100,
                    },
                },        
                sapSyncParamMapping: {}, 
            }
        },
        computed: {
            ...mapState({
                authUserPermission :state => state.auth.userPermission
            }),
        },
        mounted() {
            this.get()
        },
        methods: {
            handleTableAction(command) {
                switch (command.action) {
                    case 'edit':
                            this.edit(command.data);
                        break;
                    case 'remove':
                            this.remove(command.data);
                        break;
                    default:
                        break;
                }
            },
            get() { 
                let context = this;               
                Api(context, sapSyncParamMapping.get(context.$route.params.id)).onSuccess(function(response) {    
                    context.table.data = response.data.data;    
                }).onFinish(function() {
                    context.onLoad = false;
                }).call();
            },
            filter() {
                this.onLoad = true;
                this.table.page.current_page = 1;
                clearTimeout(this.loadTimeout);
                this.loadTimeout = setTimeout(() => {
                    this.get()
                }, 100);
            },
            changePage(page) {
                let context = this;
                context.onLoad = true;
                clearTimeout(this.loadTimeout);
                this.loadTimeout = setTimeout(() => {
                    this.get()
                }, 100);
            },
            create() {
                this.errorMessage  = null;
                this.form.add      = true;
                this.form.title    = this.tt('add');
                this.form.show     = true;
                this.sapSyncParamMapping = {
                    sap_sync_param_id: this.$route.params.id
                };
            },
            edit(id) {
                this.errorMessage = null;
                let context       = this;   

                Api(context, sapSyncParamMapping.show(id)).onSuccess(function(response) {
                    context.sapSyncParamMapping = response.data.data;
                    context.form.add      = false;
                    context.form.title    = context.tt('edit');
                    context.form.show     = true;                          
                })
                .call()        
            },
            save() {                      
                this.btnSave.onLoading = true;
                let api     = null;
                let context = this;

                if (this.form.add) {
                    api = Api(context, sapSyncParamMapping.create(this.sapSyncParamMapping));
                } else {{
                    api = Api(context, sapSyncParamMapping.update(this.sapSyncParamMapping.id, this.sapSyncParamMapping));
                }}
                api.onSuccess(function(response) {
                    context.get();
                    context.$notify({
                        message: response.data.message,                  
                        type: 'success',
                        verticalAlign: 'bottom', 
                        horizontalAlign: 'left'
                    });
                    context.form.show = false;
                }).onError(function(error) {                    
                    context.errorMessage = error.response.data;
                }).onFinish(function() {
                    context.btnSave.onLoading = false;   
                })
                .call();
            },
            remove(id) {
                this.confirmDialog(this.tt('confirm_delete')).then((result) => {
                    let context = this;
                    if (result.value) {
                        Api(context, sapSyncParamMapping.delete(id)).onSuccess(function(response) {
                            context.$notify({
                                message: response.data.message,
                                type: 'success',
                                verticalAlign: 'bottom', 
                                horizontalAlign: 'left'
                            });
                            context.get();
                        }).call();
                    }
                })
            },
        }   
    };
</script>
<style></style>
